
import { NavLink, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { navLinks } from './SidebarNavLinks';
import { FaSignOutAlt, FaBars } from 'react-icons/fa';


export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Set favicon and page title
  useEffect(() => {
    // Set favicon
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://extensionerp.com/wp-content/themes/themedemo/assets/images/favicon.png';
    // Set page title
    document.title = 'HRMS - Employee Management';
  }, []);

  useEffect(() => {
    function parseQueryToObj(url) {
      // Find the position of '?'
      const queryStartIndex = url.indexOf("?");

      // If '?' is found, extract the part after it
      if (queryStartIndex !== -1) {
        const queryString = url.substring(queryStartIndex + 1);

        // Split the query string into key-value pairs
        const pairs = queryString.split("&");
        const queryObj = {};

        // Iterate over each pair and split into key and value
        pairs.forEach((pair) => {
          const [key, value] = pair.split("=");
          if (key) {
            queryObj[decodeURIComponent(key)] = decodeURIComponent(value || "");
          }
        });

        return queryObj;
      }

      // If no query string is found, return an empty object
      return {};
    }

    // Example usage
    const url = window.location.href;
    const parsedQueryObj = parseQueryToObj(url);
    const appUrl = parsedQueryObj?.["some_url"];
    console.log({ parsedQueryObj });
    if (appUrl) {
      console.log(appUrl);
      return navigate(`/${appUrl.replace("/app", "")}`, { replace: true });
    }
  },[navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  // Sidebar content for desktop and mobile
  const sidebarContent = (
    <div className="flex flex-col h-full relative">
      {/* Logo and App Name */}
      <div className="flex items-center gap-2 h-20 px-6 border-b border-white/10">
        <div className="bg-white rounded-lg p-2 flex items-center justify-center shadow-md">
          <img src={"https://extensionerp.com/wp-content/themes/themedemo/assets/images/favicon.png"} alt="Logo" className="h-7" />
        </div>
        <span className="ml-2 font-bold text-lg text-white tracking-wide">HRMS</span>
      </div>
      {/* Nav Links */}
      <nav className="flex-1 py-4 flex flex-col gap-1">
        {navLinks.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-6 py-3 rounded-lg transition-colors text-base font-medium 
              ${isActive ? 'bg-sky-600/20 text-sky-300 shadow' : 'hover:bg-white/10 hover:text-sky-300 text-white'}`
            }
            onClick={() => setOpen(false)}
          >
            <link.icon className="text-xl" />
            {link.label}
          </NavLink>
        ))}
      </nav>
      {/* Divider */}
      <div className="border-t border-white/10 mx-4 my-2" />
      {/* Logout Button */}
      <button
        onClick={handleLogout}
        className="flex items-center box-border absolute bottom-4 left-4 right-4 bg-red-600 hover:bg-red-700 text-white py-2 rounded-md justify-center shadow-md transition-colors"
      >
        <FaSignOutAlt className="text-lg" />
        Logout
      </button>
    </div>
  );

  return (
    <>
      {/* Mobile Hamburger */}
      <div className="md:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setOpen(true)}
          className="bg-gradient-to-b from-indigo-900 to-blue-700 text-white p-2 rounded shadow-lg focus:outline-none"
        >
          <FaBars className="text-2xl" />
        </button>
      </div>
      {/* Sidebar for desktop */}
      <aside className="hidden md:flex flex-col fixed left-0 top-0 h-screen w-64 bg-gradient-to-b from-indigo-900 to-blue-700 text-white shadow-lg z-40">
        {sidebarContent}
      </aside>
      {/* Overlay and sidebar for mobile */}
      {open && (
        <div className="fixed inset-0 z-50 flex">
          <div className="w-64 bg-gradient-to-b from-indigo-900 to-blue-700 text-white shadow-lg h-full relative animate-slideInLeft">
            {sidebarContent}
          </div>
          <div
            className="flex-1 bg-black bg-opacity-40"
            onClick={() => setOpen(false)}
          />
        </div>
      )}
      {/* Spacer for sidebar */}
      <div className="md:block hidden w-64 flex-shrink-0" />
    </>
  );
}
